module.exports = __webpack_public_path__ + "img/user-13.01699e42.svg";